const couponTypesWithSyncStatus = {
  opentix: 'openTixStatus',
  pospal: 'posPalStatus',
  tkhspc: 'tkhspcStatus',
  cyjPos: 'cyjPosStatus',
}

const couponSyncStatusConfig = {
  unsync: { label: '未同步', tagType: 'warning' },
  synced: { label: '已同步', tagType: 'success' },
  failed: { label: '同步失敗', tagType: 'danger' },
  unrecorded: { label: '未紀錄', tagType: 'info' },
}

const getCouponSyncStatus = (couponRecord) => {
  const type = couponRecord?.Coupon?.type || couponRecord?.type
  const statusKey = couponTypesWithSyncStatus[type]

  if (!statusKey) return null

  return couponRecord?.extraStatus?.[statusKey]?.status || 'unrecorded'
}

export const getCouponSyncStatusDisplay = (couponRecord) => {
  const status = getCouponSyncStatus(couponRecord)

  if (status === null) {
    return { label: '-', tagType: 'info', isTag: false }
  }

  const config = couponSyncStatusConfig[status]
  return {
    label: config?.label || status,
    tagType: config?.tagType || 'info',
    isTag: true,
  }
}

export const getCouponSyncStatusLabel = (couponRecord) => {
  return getCouponSyncStatusDisplay(couponRecord).label
}
